import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState } from 'react';
import { TaktIdProvider, createStormTaktId, useIsMobile, TextButton, Button, Sheet, Popover } from '@amzn/storm-ui';
import { g as getTranslationComponent } from '../../../i18n/PageHeaderTranslation/index-D-JlEl92.js';
import { I as IntlProvider } from '../../../LocalModules/storm-ui-intl/dist/esm/IntlProvider-DmRs8GLp-yq9BpgTU.js';
import { u as useIntl } from '../../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BLE3wELi-CV9fXVbx.js';

const LocalizedPopoverAction = ({
  id,
  label,
  state = 'active',
  children,
  buttonVariant = 'default',
  popoverPosition = 'top',
  ...rest
}) => {
  const {
    formatMessage
  } = useIntl();
  const [show, setShow] = useState(false);
  const isMobile = useIsMobile();
  const triggerRef = /*#__PURE__*/React__default.createRef();
  const handleToggle = () => {
    if (state === 'active') {
      setShow(!show);
    }
  };
  const trigger = buttonVariant === 'link' ? /*#__PURE__*/React__default.createElement(TextButton, _extends({}, rest, {
    id: id,
    loading: state === 'loading',
    disabled: state === 'disabled',
    onClick: handleToggle,
    ref: triggerRef
  }), label) : /*#__PURE__*/React__default.createElement(Button, _extends({}, rest, {
    id: id,
    variant: buttonVariant,
    loading: state === 'loading',
    disabled: state === 'disabled',
    onClick: handleToggle,
    buttonRef: triggerRef
  }), label);
  if (isMobile) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Sheet, {
      isOpen: show,
      closeButton: {
        type: 'icon',
        label: formatMessage({
          id: 'close-label'
        })
      },
      onClose: () => setShow(false),
      toggleEl: triggerRef,
      side: "bottom"
    }, children), trigger);
  }
  return /*#__PURE__*/React__default.createElement(Popover, {
    id: id,
    isOpen: show,
    trigger: trigger,
    position: popoverPosition,
    withCloseButton: true,
    onCloseButtonClick: handleToggle
  }, children);
};
const PopoverAction = ({
  locale = 'en-US',
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('page-header-popover-action')
}, /*#__PURE__*/React__default.createElement(IntlProvider, {
  resetKey: locale,
  translations: getTranslationComponent(locale)
}, /*#__PURE__*/React__default.createElement(LocalizedPopoverAction, rest)));

export { PopoverAction as P };
//# sourceMappingURL=PopoverAction-DVzVarFn.js.map
